<h1 mat-dialog-title>Beschreibung bearbeiten</h1>
<mat-divider style="margin: 1rem"></mat-divider>
<mat-dialog-content class="mat-typography">
  <ng-container>
    <h5>{{"Option" | translate}}: {{optionType.Name}} ({{optionType.LicenceOption}})</h5>
  </ng-container>
  <form [formGroup]="form">
    <h3>Bearbeite die Beschreibung</h3>
    <mat-form-field>
      <input matInput placeholder="Beschreibung..." formControlName="description">
    </mat-form-field>
    <h3>Bearbeite die Beschreibung (Englisch</h3>
    <mat-form-field>
      <input matInput placeholder="Description..." formControlName="descriptionEn">
    </mat-form-field>
  </form>

  <div class="float-right">
    <button mat-button mat-dialog-close>{{"Cancel" | translate}}</button>
    <button
      mat-flat-button
      color="primary"
      class="ml-2"
      (click)="save()"
    >
      {{"Save" | translate}}
    </button>
  </div>
</mat-dialog-content>
